import { render } from "./TenantBroadcastDialog.vue?vue&type=template&id=42ddcdeb&scoped=true"
import script from "./TenantBroadcastDialog.vue?vue&type=script&lang=js"
export * from "./TenantBroadcastDialog.vue?vue&type=script&lang=js"

import "./TenantBroadcastDialog.vue?vue&type=style&index=0&id=42ddcdeb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ddcdeb"]])

export default __exports__